"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;
const keys = exports.keys = ['xs', 'sm', 'md', 'lg', 'xl'];

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
    values = {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    },
    unit = 'px',
    step = 5
  } = breakpoints;
  function up(key) {
    const value = typeof key === 'number' ? key : values[key];
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    let value;
    if (typeof key === 'number') {
      value = key;
    } else {
      const endIndex = keys.indexOf(key) + 1;
      if (endIndex === keys.length) {
        // xl down applies to all sizes
        return up('xs');
      }
      value = values[keys[endIndex]];
    }
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const startValue = typeof start === 'number' ? start : values[start];
    let endValue;
    if (typeof end === 'number') {
      endValue = end;
    } else {
      const endIndex = keys.indexOf(end);
      if (endIndex === keys.length - 1) {
        return up(start);
      }
      endValue = values[keys[endIndex + 1]];
    }
    return `@media (min-width:${startValue}${unit}) and ` + `(max-width:${endValue - step / 100}${unit})`;
  }
  function only(key) {
    return between(key, key);
  }
  function width(key) {
    return values[key];
  }
  return {
    keys,
    values,
    up,
    down,
    between,
    only,
    width
  };
}